import { render, staticRenderFns } from "./BasicsWriteTwo.vue?vue&type=template&id=8ef4c136&scoped=true"
import script from "./BasicsWriteTwo.vue?vue&type=script&lang=js"
export * from "./BasicsWriteTwo.vue?vue&type=script&lang=js"
import style0 from "./BasicsWriteTwo.vue?vue&type=style&index=0&id=8ef4c136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef4c136",
  null
  
)

export default component.exports